import config from 'config';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import "LIBRARY/Components/User/UserIssuedResources/userIssuedResorces.css";
import LibraryApiCall from 'LibraryApiCall';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class StudentRules extends Component {

    constructor(props) {
        super(props);
        this.state = {
            offset: 0,
            pageIndex: 1,
            limit: 10,

            //VARIABLE TO GET PERIODICAL DATA LIST
            ruleDataLoading: false,
            ruleData: {},
            rulesAttachment: []
        }
    }

    componentDidMount() {
        this.GetInstituteLibraryRules();
    }

    //API CALL METHOD TO GET Institute
    GetInstituteLibraryRules = async () => {
        this.setState({ ruleDataLoading: true })

        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteLibraryRules',
            requestData,
            '/api/library/learner.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstituteLibraryRules();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        this.setState({
                            ruleData: apiResult.data,
                            rulesAttachment: apiResult.data?.general?.rule_Attachments,
                            ruleDataLoading: false
                        });
                    } else {
                        this.setState({
                            ruleData: {},
                            rulesAttachment: [],
                            ruleDataLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        ruleData: {},
                        rulesAttachment: [],
                        ruleDataLoading: false,
                    });
                }

            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting list. Please try again later.'
                });
            }
        }
    }

    viewSingleResourceDetails = (item) => {
        this.setState({
            selectedAttachment: item,
            viewAttachment: true
        });
    };

    closeAdvanceFilterModal = () => {
        this.setState({
            viewAttachment: false,
            selectedAttachment: [],
        })
    }

    // METHOD TO View Attachment
    returnViewAttachmentModelData = () => {
        return (
            <div
                className={this.state.viewAttachment ? "modal fade show" : "modal fade"}
                id="modalContainer"
                style={{ display: this.state.viewAttachment ? 'block' : 'none' }}
            >
                <div
                    className="modal-dialog modal-dialog-centered modal-xl"
                    style={{ maxWidth: '60vw' }}
                >
                    <div
                        className="modal-content"
                        style={{
                            height: '65vh',        // MAIN CONTROL
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        {/* Modal Header */}
                        <div
                            className="modal-header"
                            style={{
                                padding: '20px 25px',
                                borderBottom: '2px solid #e0e0e0'
                            }}
                        >
                            <h6 className="modal-title">
                                View Attachment - {this.state.selectedAttachment?.attachmentName}
                            </h6>

                            <FontAwesomeIcon
                                icon={['fas', 'times']}
                                size="sm"
                                onClick={this.closeAdvanceFilterModal}
                                style={{ cursor: "pointer" }}
                            />
                        </div>

                        {/* Modal Body */}
                        <div
                            className="modal-body"
                            style={{
                                flex: 1,
                                overflow: 'hidden',
                                padding: 0
                            }}
                        >
                            {this.state.selectedAttachment?.attachmentPath ? (
                                <iframe
                                    className='p-2'
                                    src={this.state.selectedAttachment.attachmentPath}
                                    title="Attachment Viewer"
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        border: 'none'
                                    }}
                                />
                            ) : (
                                <div
                                    style={{
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#777'
                                    }}
                                >
                                    No valid PDF found
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const { ruleData } = this.state;
        const generalRules = ruleData.general?.rule_description || "";
        const studentRules = ruleData.student || {};

        return (
            <>
                <RoutingMenu activeScreen="userRules" />

                <div className="libraryComponents-container pr-6 pl-6">
                    {/* Page Heading */}
                    <div className="pb-4">
                        <div className="pt-1 pb-2">
                            <h4 className="text-xl font-semibold">Library Rules</h4>
                        </div>
                    </div>

                    {/* Library Info Card */}
                    <div className="bg-white border border-gray-200 p-3 mb-6" style={{ borderRadius: "12px" }}>
                        <div className="flex items-start gap-4">
                            {this.state.ruleDataLoading ? (
                                <ButtonLoader />
                            ) : generalRules ? (
                                ReactHtmlParser(generalRules)
                            ) : (
                                <p className="text-sm text-gray-500 mt-2">
                                    Please add the general rules for library from 'Action' menu.
                                </p>
                            )}

                        </div>
                    </div>

                    {/* Library Rules Display Uploaded attachment */}
                    <div className="bg-white border border-gray-200 overflow-hidden mt-4" style={{ borderRadius: "12px" }}>
                        <div className="table-responsive fixTableHead table_pad" id='tableResponsive' style={{ minHeight: '120px' }}>
                            <div className="print-area">
                                <table className="table table-bordered  vm_libraryReport_table" id="studentGeneralRules">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Attachment Type</th>
                                            <th>File Name</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.ruleDataLoading ? (
                                            <tr>
                                                <td colSpan="3" className="text-center">
                                                    <ButtonLoader />
                                                </td>
                                            </tr>
                                        ) : this.state.rulesAttachment &&
                                            this.state.rulesAttachment.filter(a => a.attachmentName).length > 0 ? (

                                            this.state.rulesAttachment
                                                .map((item, index) => (
                                                    <tr key={item.attachmentUniqueId}>
                                                        <td>{index + 1}</td>

                                                        <td>PDF</td>

                                                        <td>{item.attachmentName}</td>

                                                        <td className="table-rows vm_custom_body5 printHide" style={{ border: '1.01px solid #E0E8EF', padding: '1.5rem' }}>
                                                            <FontAwesomeIcon icon={['far', 'eye']} size="lg" title="Click to view resource details" style={{ cursor: "pointer", marginRight: 5 }} onClick={() => this.viewSingleResourceDetails(item)} />
                                                        </td>
                                                    </tr>
                                                ))

                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="text-center text-muted">
                                                    No attachments available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>

                    {/* Policy Table */}
                    <div className="bg-white border border-gray-200 overflow-hidden mt-4" style={{ borderRadius: "12px" }}>
                        <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                            <div className="print-area">
                                <table className="table table-bordered  vm_libraryReport_table" id="studentGeneralRules">
                                    <thead>
                                        <tr>
                                            <tr className='d-none'>
                                                <th colSpan="3"></th>
                                            </tr>
                                            <th>Policy</th>
                                            <th>Rule</th>
                                            <th>Value</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            this.state.ruleDataLoading ?
                                                <tr>
                                                    <td colSpan="3">
                                                        <ButtonLoader />
                                                    </td>
                                                </tr> :
                                                Object.keys(studentRules).map((key, index) => {
                                                    const rule = studentRules[key];
                                                    return (
                                                        <React.Fragment key={key}>
                                                            <tr className="border-t">
                                                                <td
                                                                    rowSpan="5"
                                                                    className="align-top py-4 px-4 font-medium text-gray-700"
                                                                >
                                                                    {rule.name}
                                                                </td>
                                                                <td className="py-3 px-4 border-t">Number of resources / periodicals can hold</td>
                                                                <td className="py-3 px-4 border-t">{rule.NumberOfResources}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-3 px-4 border-t">Number of days resources / periodicals can hold</td>
                                                                <td className="py-3 px-4 border-t">{rule.NumberOfDays}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-3 px-4 border-t">Fine per day (₹)</td>
                                                                <td className="py-3 px-4 border-t">{rule.PerDayFine}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-3 px-4 border-t">Resource damaged cost (₹)</td>
                                                                <td className="py-3 px-4 border-t">{rule.ResourceDamagedCost}</td>
                                                            </tr>
                                                            <tr>
                                                                <td className="py-3 px-4 border-t">Resource lost cost (₹)</td>
                                                                <td className="py-3 px-4 border-t">{rule.ResourceLostCost}</td>
                                                            </tr>
                                                        </React.Fragment>
                                                    );
                                                })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>

                {
                    this.returnViewAttachmentModelData()
                }
            </>
        );
    }

}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin,
        iidArray: { ...store.RouteMenuReducer.iidArray }
    };
};

export default connect(mapStateToProps)(StudentRules);